module.exports = __webpack_public_path__ + "img/plus.0b12c46f.svg";